import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import { useHistory } from 'react-router-dom';
import { LIMIT_INCREASE, REMOVE_BRANDING, UNCATEGORIZED } from 'self-service-api/constants/FeatureCategories';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import { MERCH_CARD } from '../../../constants/tracking/TrackingSources';
import { useBusinessObjectivesForApiNames } from '../../../hooks/useBusinessObjectives';
import { useFTS0012Experiment } from '../../../utils/experiments/fts0012';
import { trackClickedLink } from '../../../utils/tracking/trackingEventUtils';
import SkeletonLoadWrapper from '../../common/loading/SkeletonLoadWrapper';
import BusinessObjectivesFeatures from './BusinessObjectivesFeatures';
import BusinessObjectivesFeaturesBullet from './BusinessObjectivesFeaturesBullet';
import BusinessObjectivesLowerTierMessage from './BusinessObjectivesLowerTierMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BusinessObjectivesContainer = ({
  productLine,
  productLevel,
  apiName
}) => {
  var _BO$features;
  const {
    businessObjectives,
    loading
  } = useBusinessObjectivesForApiNames({
    highlightedProducts: [apiName]
  });
  const BO = businessObjectives.find(bo => bo.productApiName === apiName);
  const features = (BO === null || BO === void 0 || (_BO$features = BO.features) === null || _BO$features === void 0 ? void 0 : _BO$features.filter(feature => !feature.hideFromLang)) || [];
  const brandingAndLimitFeatures = features.filter(feature => feature.featureCategory === LIMIT_INCREASE || feature.featureCategory === REMOVE_BRANDING);
  const uncategorizedFeatures = features.filter(feature => feature.featureCategory === UNCATEGORIZED);
  const history = useHistory();
  const handleClick = () => {
    trackClickedLink({
      name: 'business-objective-link',
      value: getI18nText('merchCards.businessObjectives.freeToolsWithLimits', {
        locale: 'en-us'
      }),
      type: 'internal',
      url: '/crm',
      trackingSource: MERCH_CARD
    });
    history.push('/crm');
  };
  const {
    isFTS0012Variant
  } = useFTS0012Experiment();
  if (isFTS0012Variant && productLevel === STARTER) {
    return /*#__PURE__*/_jsxs(SkeletonLoadWrapper, {
      isLoading: loading,
      heights: [48, 48],
      widths: ['100%', '100%'],
      children: [/*#__PURE__*/_jsx(PPUIGridItem, {
        "data-selenium-id": "biz-objectives-1",
        paddingBlockStart: "800",
        children: /*#__PURE__*/_jsx(View, {
          paddingBlockEnd: "300",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "merchCards.businessObjectives.freeToolsPlus",
            options: {
              freeToolsWithIncreasedLimits: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "merchCards.businessObjectives.freeToolsWithLimits"
              })
            }
          })
        })
      }), /*#__PURE__*/_jsxs(PPUIGridItem, {
        "data-selenium-id": "biz-objectives-2",
        marginBlockEnd: "700",
        children: [brandingAndLimitFeatures.length > 0 && /*#__PURE__*/_jsx(BusinessObjectivesFeaturesBullet, {
          features: brandingAndLimitFeatures
        }), /*#__PURE__*/_jsx(BusinessObjectivesFeatures, {
          features: uncategorizedFeatures
        })]
      })]
    });
  }
  if (brandingAndLimitFeatures.length) {
    return /*#__PURE__*/_jsxs(SkeletonLoadWrapper, {
      isLoading: loading,
      heights: [48, 48],
      widths: [180, 180],
      children: [/*#__PURE__*/_jsx(PPUIGridItem, {
        "data-selenium-id": "biz-objectives-1",
        paddingBlockStart: "800",
        children: /*#__PURE__*/_jsx(View, {
          paddingBlockEnd: "300",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "merchCards.businessObjectives.freeToolsRemoveBranding",
            options: {
              freeToolsWithIncreasedLimits: /*#__PURE__*/_jsx(Link, {
                onClick: handleClick,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "merchCards.businessObjectives.freeToolsWithLimits"
                })
              })
            }
          })
        })
      }), /*#__PURE__*/_jsxs(PPUIGridItem, {
        "data-selenium-id": "biz-objectives-2",
        marginBlockEnd: "700",
        children: [/*#__PURE__*/_jsx(BusinessObjectivesFeatures, {
          features: brandingAndLimitFeatures
        }), /*#__PURE__*/_jsx(View, {
          paddingBlockStart: "300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "merchCards.businessObjectives.and"
          })
        }), /*#__PURE__*/_jsx(BusinessObjectivesFeatures, {
          features: uncategorizedFeatures
        })]
      })]
    });
  }
  return /*#__PURE__*/_jsxs(SkeletonLoadWrapper, {
    isLoading: loading,
    heights: [48, 48],
    widths: ['100%', '100%'],
    children: [/*#__PURE__*/_jsx(PPUIGridItem, {
      "data-selenium-id": "biz-objectives-1",
      paddingBlockStart: "800",
      marginBlockEnd: "700",
      children: /*#__PURE__*/_jsx(BusinessObjectivesLowerTierMessage, {
        productLevel: productLevel,
        productLine: productLine,
        handleClick: handleClick
      })
    }), /*#__PURE__*/_jsx(PPUIGridItem, {
      "data-selenium-id": "biz-objectives-2",
      children: /*#__PURE__*/_jsx(BusinessObjectivesFeatures, {
        features: uncategorizedFeatures
      })
    })]
  });
};
export default BusinessObjectivesContainer;